module.exports = __webpack_public_path__ + "static/img/3.3eea7cc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/3.png
// module id = 0SYH
// module chunks = 1